import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { GenericBaryFormGroup } from './GenericBaryFormGroup';

export class FormGroupHelper {
  protected form: any;

  focusOnFirstError(): void {
    if (document.getElementsByClassName('ng-invalid')?.length) {
      document.getElementsByClassName('ng-invalid')[0].scrollTo();
      (document.getElementsByClassName('ng-invalid')[0] as HTMLElement).focus();
    }
  }

  validateForm(): boolean {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.focusOnFirstError();
      return false;
    } else {
      return true;
    }
  }

  protected newFormGroup(controls: any, validators?: any): FormGroup {
    const formGroup = new FormGroup({}, validators);
    this.addControls(formGroup, controls);
    return formGroup;
  }

  private addControls(formGroup: FormGroup, controls: any): void {
    Object.keys(controls).forEach(controlsKey => {
      const control = controls[controlsKey];
      if (control instanceof AbstractControl) {
        formGroup.addControl(controlsKey, control);
      } else if (control instanceof Array) {
        // genericFormGroup[]
        const formArray = new FormArray([]);
        control.forEach((itemControl: GenericBaryFormGroup<any>) => {
          formArray.push(itemControl.getAngularForm() as never);
        });
        formGroup.addControl(controlsKey, formArray);
      } else {
        // genericFormGroup, using from to include this control.
        formGroup.addControl(controlsKey, control['form']);
      }
    });
  }
}
